import React, { Component } from "react";
import {
  getSingle,
  getAccountCompany,
  getSingleYard,
} from "../../services/yardService";
import { getLedgerTypes } from "../../services/yardLedgerTypeService";
import {
  saveSingle,
  getAllLedgers,
  deleteLedger,
} from "../../services/yardLedgerService";
import YardLedgerTable from "./ledgerTable";
import {
  Table,
  Grid,
  Confirm,
  Button,
  Message,
  Statistic,
} from "semantic-ui-react";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Link } from "react-router-dom";
import Pagination from "../common/pagination";
import { paginate } from "../../utils/paginate";
import TableTitle from "../common/tableTitle";
import Form from "../common/form";
import Joi from "joi-browser";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import _, { join } from "lodash";
import SearchTextBox from "../common/searchTextBox";
import LedgerNetBalance from "../common/ledgernetbalance";
import ReactToPrint from "react-to-print";
import queryString from "query-string";

class YardDetail extends Form {
  state = {
    visa: {},
    yardId: "",
    open: false,
    paymentDate: new Date(),
    ledgerTypes: [],
    ledgerType: 1,
    data: {
      payment: "",
      description: "",
    },
    errors: {},
    payments: [],
    pageSize: 5000,
    currentPage: 1,
    keyFieldValue: "",
    sortColumn: { path: "sort_date", order: "asc" },
    debit: 0,
    credit: 0,
    balance: 0,
    companyId: "",
    ledgerTypeName: "",
    startDate: "",
    endDate: "",
  };

  schema = {
    id: Joi.string(),
    description: Joi.string().required().label("Description"),
    payment: Joi.number().required().label("Payment"),
  };

  async getVisaDetail(yardId) {
    try {
      this.setState({ blocking: true });

      const { data: visa } = await getSingleYard(yardId, this.state.companyId);

      this.setState({ visa, blocking: false });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async getCompanyId(visaId) {
    try {
      this.setState({ blocking: true });

      let companyId = await getAccountCompany(visaId);

      this.setState({ companyId: companyId.data, blocking: false });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  statistics = (data) => {
    let debit = 0;
    let credit = 0;
    let balance = 0;

    data.map((trans) => {
      trans.credit > 0
        ? (credit = credit + parseInt(trans.credit))
        : (debit = debit + parseInt(trans.debit));
    });

    balance = credit - debit;

    this.setState({ debit, credit, balance });
  };

  async componentDidMount() {
    const yardId = this.props.match.params.id;

    await this.getCompanyId(yardId);

    await this.getVisaDetail(yardId);

    localStorage.setItem("yardId", yardId);

    const { data: ledgerTypes } = await getLedgerTypes(this.state.companyId);

    const { data: payments } = await getAllLedgers();

    this.statistics(payments);

    this.setState({ blocking: false, ledgerTypes, payments, yardId: yardId });
  }

  handleDeleteLedger = (type) => {
    this.setState({ openLedger: true, type });
  };

  doDeleteLedger = async () => {
    const type = this.state.type;
    const originalTypes = this.state.payments;
    const payments = originalTypes.filter((o) => o.id !== type.id);
    this.setState({ payments, openLedger: false });

    try {
      await deleteLedger(type.id);

      toast.success("Ledger has been deleted successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        toast.success("This Ledger has already been deleted.");
      }

      this.setState({ types: originalTypes });
    }
  };

  handleUpdateLedger = (type) => {
    return this.props.history.replace("/yards-ledgers/" + type.id + "/edit");
  };
  handleCancel = () => {
    this.setState({ open: false });
  };

  handleCancelLedger = () => {
    this.setState({ openLedger: false });
  };

  handleChangePaymentDate = (date) => {
    this.setState({
      paymentDate: date,
    });
  };

  updateLedgerType = (ledgerType, ledgerTypeName) => {
    this.setState({ ledgerType, ledgerTypeName });
  };

  doFilterPaymentsData = async () => {
    try {
      var event = new Date(this.state.startDate);
      event.setDate(event.getDate() + 1);
      let startDate = JSON.stringify(event);
      startDate = startDate.slice(1, 11);

      event = new Date(this.state.endDate);
      event.setDate(event.getDate() + 1);
      let endDate = JSON.stringify(event);
      endDate = endDate.slice(1, 11);

      this.setState({ blocking: true });

      const verifyData = {
        startDate: startDate,
        endDate: endDate,
      };

      this.reportInitialLoading(verifyData);
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  doReset = () => {
    const verifyData = {
      startDate: "",
      endDate: "",
    };
    this.setState({ startDate: "", endDate: "" });
    this.reportInitialLoading(verifyData);
  };

  async reportInitialLoading(verifyData) {
    this.setState({ blocking: true });

    const { data: payments } = await getAllLedgers(verifyData);
    this.statistics(payments);

    this.setState({ blocking: false, payments, showError: false });
  }

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
      const data = { ...this.state.data };
      data.yard_ledger_type_id = this.state.ledgerType;

      var event = new Date(this.state.paymentDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      data.payment_date = date;

      await saveSingle(data);

      const { data: payments } = await getAllLedgers();

      toast.success("Ledger has been added successfully.");
      this.setState({
        blocking: false,
        ledgerType: 1,
        data: { payment: "" },
        payments,
      });
      this.props.history.push(
        "/yards-accounts/view/" + localStorage.getItem("yardId")
      );
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.payment)
          errors.payment = ex.response.data.errors.payment;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      payments: allPayments,
      keyFieldValue,
      sortColumn,
    } = this.state;

    let filtered = allPayments;
    filtered = keyFieldValue
      ? filtered.filter(
          (m) =>
            m.yard_ledger_type.name
              .toUpperCase()
              .indexOf(keyFieldValue.toUpperCase()) > -1
        )
      : filtered;

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const payments = paginate(sorted, currentPage, pageSize);
    return { totalCount: filtered.length, data: payments };
  };

  handleSearching = (keyword) => {
    this.setState({ keyFieldValue: keyword, currentPage: 1 });
  };

  formatBalance = () => {
    let fBalance;
    let balance = this.state.balance.toString();
    //if(balance < 0){
    if (this.state.debit > this.state.credit) {
      return balance.replace("-", "");
    } else {
      fBalance = "(" + balance.replace("-", "") + ")";
      return fBalance;
    }
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  render() {
    const { visa } = this.state;
    const { pageSize, currentPage, sortColumn } = this.state;
    const { totalCount, data: payments } = this.getPagedData();
    let { keyword, status, origin } = queryString.parse(
      this.props.location.search
    );

    let backUrl = "yards-accounts";
    if (origin === "dashboard") {
      backUrl = "dashboard";
    }
    if (origin === "scrap") {
      backUrl = "report/scrap";
    }
    if (origin === "jv") {
      backUrl = "report/jv";
    }
    if (origin === "payable") {
      backUrl = "report/generate-payable-report";
    }
    if (origin === "receivable") {
      backUrl = "report/generate-receiveable-report";
    }

    if (keyword === undefined) {
      keyword = "";
    }

    if (status === undefined) {
      status = "";
    }

    if (origin === undefined) {
      origin = "";
    }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirm
          open={this.state.openLedger}
          header="Confirmation"
          content="Are you sure, you want to delete the ledger?"
          onCancel={this.handleCancelLedger}
          onConfirm={this.doDeleteLedger}
          size="mini"
        />

        <h1 className="container__heading">Yard Account Detail</h1>

        <Link
          to={`/${backUrl}?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary account-detail-page-btn"
        >
          Back
        </Link>

        <section className="grid grid--1x4 detail-basic-info">
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Visa Account</div>
            <div className="detail-basic-info__unit-value">{visa.visa_id}</div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Name</div>
            <div className="detail-basic-info__unit-value">{visa.name}</div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Expiry Date</div>
            <div className="detail-basic-info__unit-value">
              {visa.expiry_date}
            </div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Mobile</div>
            <div className="detail-basic-info__unit-value">{visa.mobile}</div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Rent</div>
            <div className="detail-basic-info__unit-value">{visa.rent}</div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Emirates Id</div>
            <div className="detail-basic-info__unit-value">
              {visa.emirates_id}
            </div>
          </div>
        </section>

        <h1 className="container__heading account-detail-page-title">
          Yard Account Ledgers
        </h1>

        <div className="grid grid--1x3 account-detail-page-stats">
          <span className="icon-container account-detail-page-stats__icon">
            <span className="dashboard-accounts-stats__label">
              {this.state.credit}
            </span>
            <span className="dashboard-accounts-stats__heading account-detail-page-stats__label">
              Credit
            </span>
          </span>
          <span className="icon-container account-detail-page-stats__icon">
            <span className="dashboard-accounts-stats__label">
              {this.state.debit}
            </span>
            <span className="dashboard-accounts-stats__heading account-detail-page-stats__label">
              Debit
            </span>
          </span>
          <span className="icon-container account-detail-page-stats__icon">
            <span className="dashboard-accounts-stats__label">
              {" "}
              {this.formatBalance()}
            </span>
            <span className="dashboard-accounts-stats__heading account-detail-page-stats__label">
              Balance
            </span>
          </span>
        </div>

        <div className="grid account-detail-page-filters">
          <DatePicker
            selected={this.state.startDate}
            onChange={this.handleChangeStartDate}
            placeholderText="Select Start Date"
            className="input"
          />
          <div></div>
          <DatePicker
            selected={this.state.endDate}
            onChange={this.handleChangeEndDate}
            className="input"
            placeholderText="Select End Date"
          />
          <div></div>
          <button
            className="btn btn--primary"
            onClick={this.doFilterPaymentsData}
          >
            Submit
          </button>
          <div></div>
          <button className="btn btn--secondary" onClick={this.doReset}>
            Reset
          </button>
        </div>

        <Message
          negative
          style={{
            display: this.state.showError == true ? "block" : "none",
          }}
        >
          <Message.Header>Error</Message.Header>
          <p>Data not found for the dates specified.</p>
        </Message>

        <div className="scrap-report">
          <div className="scrap-report__print">
            <ReactToPrint
              trigger={() => <a href="#">Print this out!</a>}
              content={() => this.componentRef}
            />
          </div>

          <LedgerNetBalance
            type="yard"
            info={this.state.visa}
            visaid={this.props.match.params.id}
            payments={payments}
            onDelete={this.handleDeleteLedger}
            onUpdate={this.handleUpdateLedger}
            ref={(el) => (this.componentRef = el)}
          />
        </div>

        <center>
          <form
            onSubmit={this.handleSubmit}
            className="error form"
            style={{ width: "35%", marginTop: "2rem" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">Add payment</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <Button.Group>
                      {this.state.ledgerTypes.map((type) => (
                        <React.Fragment>
                          <Button
                            positive={
                              this.state.ledgerTypeName === type.name
                                ? true
                                : false
                            }
                            onClick={() =>
                              this.updateLedgerType(type.id, type.name)
                            }
                          >
                            {type.name}
                          </Button>
                        </React.Fragment>
                      ))}
                      ;
                    </Button.Group>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("description", "Description", "text")}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("payment", "Payment", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {/* <label>
                      <b>Payment Date</b>
                    </label>
                    <br />
                    <DatePicker
                      className="input"
                      selected={this.state.paymentDate}
                      onChange={this.handleChangePaymentDate}
                    /> */}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>{this.renderButton("Add")}</Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <br />
            <br />
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default YardDetail;
